module.exports = __webpack_public_path__ + "img/roltek-recalculate-instructions.36eb0de4.png";